export const drawerTheme = {
  extend: {
    header: {
      padding: '0',
    },
    footer: {
      padding: '0',
    },
    custom: {
      borderWidth: '0',
      width: "375px",
      contentPadding: "1rem 1rem 1rem 1rem",
      headerPaddingTopMobile: "67px",
      headerMinHeight: "4rem"
    },
  },
  css: ({ dt }: { dt: (token: string) => string }) => `
    .p-drawer {
      padding: 0;
      width: ${dt("drawer.custom.width")};
      border-width: ${dt("drawer.custom.border.width")};
    }

    @media (min-width: 1200px) {
      .p-drawer-header {
        min-height: ${dt("drawer.custom.headerMinHeight")};
      }
    }

    @media (max-width: 1199px) {
      .p-drawer-header {
        padding-top: ${dt("drawer.custom.headerPaddingTopMobile")};
      }
    }

     @media (max-width: 1199px) {
      .p-drawer {
        width: 100%;
        z-index: 98 !important; 
      }
    }

    .p-drawer .p-drawer-content {
      height: 100%;
      display: flex;
      flex-direction: column;
      padding:  ${dt("drawer.custom.contentPadding")};
      overflow-x: hidden;
    }

    @media (max-width: 1199px) {
      .p-drawer .p-drawer-content {
        z-index: ${dt("drawer.custom.zIndexMobile")};
      }
    }
  `,
};
